import { render } from "./FilePreview.vue?vue&type=template&id=6c0c8b8a&scoped=true"
import script from "./FilePreview.vue?vue&type=script&lang=js"
export * from "./FilePreview.vue?vue&type=script&lang=js"

import "./FilePreview.vue?vue&type=style&index=0&id=6c0c8b8a&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0c8b8a"]])

export default __exports__